import React from 'react';
import { styled } from '@compiled/react';
import CalendarIcon from '@atlaskit/icon/core/calendar';
import { Box, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { useDateTimeFormatter } from '@atlassian/jira-issue-format-date/src/main.tsx';
import messages from '../../common/messages.tsx';
import { ReadViewContainer, PlaceholderSpacer } from '../../common/ui/styled.tsx';

export const DateReadView = ({
	value,
	showPlaceholderIfEmpty = true,
}: {
	value: string | null;
	showPlaceholderIfEmpty?: boolean;
}): React.JSX.Element => {
	const { formatDateOnly } = useDateTimeFormatter();
	const { formatMessage } = useIntl();
	const displayValue: string | null = value !== null && value !== '' ? formatDateOnly(value) : null;

	const placeholderText = showPlaceholderIfEmpty
		? formatMessage(messages.placeholderNoneSelected)
		: null;
	return (
		<ReadViewContainer isPlaceholder={!displayValue}>
			{displayValue !== null ? (
				<Container>
					<CalendarIcon spacing="spacious" label="" />
					<Box xcss={textStyles}>{displayValue}</Box>
				</Container>
			) : (
				<PlaceholderSpacer>{placeholderText}</PlaceholderSpacer>
			)}
		</ReadViewContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	alignItems: 'center',
});

const textStyles = xcss({
	marginLeft: 'space.100',
});
